import { useAppSelector } from '@/app/store/store';
import type { DesktopHeaderConfig, HeaderLayoutMode } from '@/features/newHome/domain/models/NewHomePageData';
import { DEFAULT_DESKTOP_HEADER } from '@/app/store/headerConfigSlice';

/** Horizontal padding matches `.container-fluid` (theme.css). */
export function headerLayoutWrapperClass(layout: HeaderLayoutMode): string {
  return layout === 'container' ? 'max-w-7xl mx-auto w-full px-[30px]' : 'container-fluid';
}

export function useDesktopHeaderConfig(): DesktopHeaderConfig {
  return useAppSelector((s) => s.headerConfig?.desktop ?? DEFAULT_DESKTOP_HEADER);
}
